import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	getMonthlyClosing,
	getOpenMonthlyClosingMonths,
} from "~/modules/timeTracking/api/monthlyClosing/monthlyClosingApiDispatchers.ts";

export const monthlyClosingQueries = {
	baseKey: ["monthlyClosing"],
	/** `month` is `YYYY-MM`. */
	month: (userId: string, month: string) =>
		queryOptions({
			queryKey: [...monthlyClosingQueries.baseKey, { userId, month }],
			queryFn: () => getMonthlyClosing(userId, month).then(getDataFromResponse),
			enabled: !!userId && !!month,
		}),
	openMonths: (userId: string) =>
		queryOptions({
			queryKey: [...monthlyClosingQueries.baseKey, "openMonths", { userId }],
			queryFn: () => getOpenMonthlyClosingMonths(userId).then(getDataFromResponse),
			enabled: !!userId,
		}),
};
